import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@hero/web-lib';

export interface DisabledScreenProps {
  icon?: ComponentType<{ className?: string }>;
  title?: string;
  message?: string;
  className?: string;
}

export function DisabledScreen({ icon: Icon, title, message, className }: DisabledScreenProps) {
  const { t } = useTranslation(['c-main']);

  return (
    <div className={cn('flex flex-1 items-center justify-center p-8', className)}>
      <div className="flex flex-col items-center gap-4 text-center max-w-md">
        {Icon && (
          <div className="rounded-full bg-muted p-6">
            <Icon className="h-12 w-12 text-muted-foreground" />
          </div>
        )}
        <span className="text-xs font-medium px-3 py-1 rounded-full bg-gray-100 text-gray-600">
          {t('c-main:feature_screen.disabled_badge')}
        </span>
        <h2 className="text-2xl font-semibold tracking-tight">
          {title ?? t('c-main:feature_screen.disabled_title')}
        </h2>
        <p className="text-muted-foreground text-base">
          {message ?? t('c-main:feature_screen.disabled_message')}
        </p>
      </div>
    </div>
  );
}
